import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    DELETE_SAMPLE_CONTAINER_TEST_MAP,
    deleteSampleContainerTestMapFail,
    deleteSampleContainerTestMapSuccess
} from '../action/deleteSampleContainerTestMapAction'

// api 
import deleteSampleContainerTestMapApi from '../api/deleteSampleContainerTestMapApi'

export function* deleteSampleContainerTestMapSaga(action) {
    try {
        const response = yield call(() => deleteSampleContainerTestMapApi(action.params))
        if (response.data.status === 1) {
            yield put(deleteSampleContainerTestMapSuccess(response, action))
        } else {
            yield put(deleteSampleContainerTestMapFail(response, action))
        }
    }
    catch (e) {
        yield put(deleteSampleContainerTestMapFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(DELETE_SAMPLE_CONTAINER_TEST_MAP, deleteSampleContainerTestMapSaga)
}